module.exports = __webpack_public_path__ + "img/icon_jxspke.70ef18fb.png";